// tslint:disable:max-line-length

import * as React from 'react';
import Title from '../components/Title';
import GoogleMapReact, { Coords } from 'google-map-react';
import DocumentTitle from 'react-document-title';
// import Navigation from '../components/Navigation';
import { RouteProps } from 'react-router';
import { NavigationStore } from './Navigation/NavigationStore';

interface IContactState {
    active: string;
}

export interface IContactProps extends RouteProps {
    center: Coords;
    zoom: number;
}

class Contact extends React.Component<IContactProps, IContactState> {
    static defaultProps = {
        center: { lat: 50.125362, lng: 14.431088 },
        zoom: 18
    };

    constructor(props: IContactProps) {
        super(props);

        // tslint:disable-next-line:triple-equals
        if (props.location != undefined && props.location.state != undefined) {
            this.state = {
                active:
                    props.location.state !== undefined
                        ? props.location.state.action
                        : 'contact'
            };
        } else {
            this.state = {
                active: 'contact'
            };
        }
    }

    componentWillReceiveProps(nextProps: IContactProps) {
        if (
            // tslint:disable-next-line:triple-equals
            nextProps.location != undefined &&
            // tslint:disable-next-line:triple-equals
            nextProps.location.state != undefined &&
            nextProps.location.state.action !== this.state.active
        ) {
            this.setState({
                active: nextProps.location.state.action
            });
        }
    }

    componentDidMount() {
        // Navigation._setActive('contact', 'Contact');
        window.scrollTo(0, 0);

        NavigationStore.getInstance().setActive('contact');
    }

    handleClick(item: string) {
        this.setState({
            active: item
        });
    }

    render() {
        return (
            <DocumentTitle title={'WetNotes | Contact'}>
                <div className="contacts">
                    <Title
                        heading={'Contact'}
                        breadcrumbs={[
                            { caption: 'Contact', to: '/app/contact' }
                        ]}
                    />

                    <div className="wrapper">
                        <div className="col__sidebar">
                            <div className="sidebarMenu">
                                <div
                                    className={
                                        'sidebarMenu__item' +
                                        (this.state.active === 'contact'
                                            ? ' current'
                                            : '')
                                    }
                                    onClick={() => this.handleClick('contact')}
                                >
                                    Contact
                                </div>
                                <div
                                    className={
                                        'sidebarMenu__item' +
                                        (this.state.active === 'user-agreement'
                                            ? ' current'
                                            : '')
                                    }
                                    onClick={() => this.handleClick('user-agreement')}
                                >
                                    User Agreement
                                </div>
                                <div
                                    className={
                                        'sidebarMenu__item' +
                                        (this.state.active === 'privacyPolicy'
                                            ? ' current'
                                            : '')
                                    }
                                    onClick={() =>
                                        this.handleClick('privacyPolicy')
                                    }
                                >
                                    Privacy Policy
                                </div>
                            </div>
                        </div>

                        <div className="col__main">
                            {this.state.active === 'contact' && (
                                <div>
                                    <div className="standardContainer">
                                        <div className="standardContainer__header">
                                            <h3>Contact</h3>
                                        </div>

                                        <div className="standardContainer__body">
                                            <div className="contactForm">
                                                <h4>WetNotes, s.r.o</h4>

                                                <p className="contactForm__address">
                                                    K Haltýři 756/14<br />
                                                    181 00 Praha 8<br />
                                                    Czech Republic<br />
                                                    <br />
                                                    Reg. ID: 05620538<br />
                                                    VAT: CZ05620538<br />
                                                    The company is incorporated
                                                    in the Commercial Register
                                                    kept by the Municipal Court
                                                    in Prague, Czech Republic: C
                                                    267499.
                                                </p>

                                                <a
                                                    className="contactForm__email"
                                                    href="mailto:info@divesoft.com"
                                                >
                                                    info@divesoft.com
                                                </a>

                                                <div className="contactForm__map">
                                                    <GoogleMapReact
                                                        defaultCenter={
                                                            this.props.center
                                                        }
                                                        defaultZoom={
                                                            this.props.zoom
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="standardContainer hidden">
                                        <div className="standardContainer__header">
                                            <h3>Contact form</h3>
                                        </div>

                                        <div className="standardContainer__body">
                                            <div className="contactForm">
                                                <form>
                                                    <div className="">
                                                        <p className="inputLabel">
                                                            Name
                                                        </p>
                                                        <input type="text" />
                                                    </div>

                                                    <div className="">
                                                        <p className="inputLabel">
                                                            Lastname
                                                        </p>
                                                        <input type="text" />
                                                    </div>

                                                    <div className="">
                                                        <p className="inputLabel">
                                                            Email
                                                        </p>
                                                        <input type="text" />
                                                    </div>

                                                    <div className="">
                                                        <p className="inputLabel">
                                                            Phone
                                                        </p>
                                                        <input type="text" />
                                                    </div>

                                                    <p className="inputLabel">
                                                        Text
                                                    </p>
                                                    <textarea />
                                                    <button className="btn btn--smallpill btn--colorRed btn--borderGray">
                                                        Send
                                                    </button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {this.state.active === 'user-agreement' && (
                                <div>
                                    <div className="standardContainer">
                                        <div className="standardContainer__header">
                                            <h3>User Agreement</h3>
                                        </div>

                                        <div className="standardContainer__body">
                                            <p>The text is being prepared...</p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {this.state.active === 'privacyPolicy' && (
                                <div>
                                    <div className="standardContainer">
                                        <div className="standardContainer__header">
                                            <h3>Privacy Policy</h3>
                                        </div>

                                        <div className="standardContainer__body">
                                            <p>The text is being prepared...</p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </DocumentTitle>
        );
    }
}

export default Contact;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Contact.tsx